module.exports = __webpack_public_path__ + "img/lg_ring_g_s_null_null@3x.88012818.png";